<!-- 巡检点位表格组件 -->
<template>
  <div class="deptcargo-table-container">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="handleSelectionChange"
    >
      <!-- 自定义点位编号列 -->
      <template slot="pointCode" slot-scope="{ row }">
        <span style="color: #409eff; cursor: pointer" @click="!selectMode">
          {{ row.pointCode }}
        </span>
      </template>

      <!-- 自定义状态列 -->
      <template slot="status" slot-scope="{ row }">
        <el-tag
          :type="getStatusTagType(row.status)"
          size="small"
          effect="light"
        >
          {{ getStatusText(row.status) }}
        </el-tag>
      </template>
    </avue-crud>
    <dialog-reset
      title="地图"
      :visible.sync="gaodeshow"
      top="5%"
      width="1000px"
      height="70vh"
      :beforeClose="handlegaodeclose"
    >
      <TiandiMap
        height="100%"
        :initial-markers="initialTiandiMarkers"
        :selectable="true"
        :show-toolbar="false"
        @map-click="locationselected"
      ></TiandiMap>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getList, add, update, remove, getDetail } from "../api";
import TiandiMap from "@/components/tiandi-map/index.vue";
import website from "@/config/website";

export default {
  name: "PointTable",
  mixins: [crudMixins],
  props: {
    // 是否是选择模式（选择模式下隐藏操作按钮）
    selectMode: {
      type: Boolean,
      default: false,
    },
    // 选择模式下的回调
    onSelect: {
      type: Function,
      default: null,
    },
    // 是否只显示启用的点位（用于选择模式）
    onlyEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TiandiMap
  },
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      gaodeshow: false,
      Inglat: [],
      defaultParams: {
        businessType: "inspection",
      },
      currentPoint: {},
      option: {
        ...this.$store.state.publicOption,
        menu: !this.selectMode, // 选择模式下隐藏菜单
        addBtn: !this.selectMode,
        delBtn: !this.selectMode,
        editBtn: !this.selectMode,
        viewBtn: !this.selectMode,
        searchMenuSpan: 6,
        selection: this.selectMode, // 选择模式下启用多选
        column: [
          {
            label: '货主名称',
            prop: 'deptName',
            maxlength: 40,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入货主名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '所属租户',
            prop: 'tenantId',
            type: 'tree',
            maxlength: 40,
            dicUrl: '/api/blade-system/tenant/select',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: website.tenantMode,
            props: {
              label: 'tenantName',
              value: 'tenantId',
            },
            hide: !website.tenantMode,
            search: website.tenantMode,
            rules: [
              {
                required: true,
                message: '请输入所属租户',
                trigger: 'click',
              },
            ],
          },
          {
            label: '货主全称',
            prop: 'fullName',
            maxlength: 40,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入货主全称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '货主编码',
            prop: 'id',
            maxlength: 20,
            search: false,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 200,
            span: 24,
            minRows: 3,
            rules: [
              {
                required: false,
                message: '请输入备注',
                trigger: 'blur',
              },
            ],
            hide: true,
          },
        ],
      },
    };
  },
  computed: {
    initialTiandiMarkers() {
      if (!this.Inglat || this.Inglat.length < 2) return [];
      return [
        {
          name: this.form.pointLocation || this.form.deptName || "当前位置",
          coordinate: this.Inglat
        }
      ];
    },
  },
  watch: {
    selectMode(val) {
      this.option.menu = !val;
      this.option.addBtn = !val;
      this.option.selection = val;
    },
    onlyEnabled(val) {
      if (val) {
        // 只显示启用的点位
        this.defaultParams.status = 1;
      } else {
        delete this.defaultParams.status;
      }
    },
  },
  methods: {
    gaodeShowFocus () {
      if (this.form.longitude) {
        let Inglat = []
        Inglat.push(this.form.longitude - 0)
        Inglat.push(this.form.latitude - 0)
        this.Inglat = Inglat
      }
      this.gaodeshow = true
    },
    handlegaodeclose() {
      this.gaodeshow = false
    },
    locationselected (val) {
      const lnglat = val.lnglat || [val.longitude, val.latitude]
      this.form.pointLocation = val.address || "厂区内部位置"
      this.form.longitude = lnglat[0]
      this.form.latitude = lnglat[1]
      this.Inglat = lnglat
      this.gaodeshow = false
    },
    // 处理选择变化
    handleSelectionChange(selection) {
      if (this.selectMode && this.onSelect) {
        this.onSelect(selection);
      } else {
        this.selectionChange(selection);
      }
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        1: "启用",
        0: "禁用",
      };
      return statusMap[status] || "未知";
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        1: "success",
        0: "danger",
      };
      return typeMap[status] || "info";
    },

    // 公开方法：刷新数据
    refresh() {
      this.onLoad(this.page);
    },

    // 公开方法：设置选中的行（用于回显）
    setSelection(selectedCodes = []) {
      console.log('[PointTable] setSelection 被调用, selectedCodes:', selectedCodes);

      if (!selectedCodes || selectedCodes.length === 0) {
        console.log('[PointTable] selectedCodes 为空');
        return;
      }

      this.$nextTick(() => {
        const crud = this.$refs.crud;
        console.log('[PointTable] crud 引用:', crud ? '存在' : '不存在');

        if (!crud) {
          return;
        }

        console.log('[PointTable] 表格数据长度:', this.data.length);

        // 根据 pointCode 筛选出要选中的行
        const selection = this.data.filter(row =>
          selectedCodes.includes(row.pointCode)
        );

        console.log('[PointTable] 筛选出的行数:', selection.length);
        console.log('[PointTable] 筛选出的行:', selection);

        if (selection.length > 0) {
          crud.toggleSelection(selection);
          console.log('[PointTable] toggleSelection 已调用');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.deptcargo-table-container {
  ::v-deep .avue-crud__search {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  }

  ::v-deep .avue-crud__table {
    .el-table__header th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
    .el-table__row:hover {
      background-color: #f5f7fa;
    }
  }

  ::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
  }

  ::v-deep .el-button--text {
    padding: 0 8px;
    margin-right: 0;
  }

  .dialog-footer {
    text-align: right;

    .el-button {
      min-width: 80px;
    }
  }

  .point-detail-form {
    ::v-deep .el-form-item {
      margin-bottom: 15px;

      .el-form-item__label {
        color: #606266;
        font-weight: 500;
      }

      span {
        color: #303133;
      }
    }
  }
}
</style>

